<template>
  <div style="width: 100%">
    <keep-alive>
      <VanOffline v-if="vanOffline.state == 'home'" />
      <QrVanOffline v-if="vanOffline.state == 'detail'" />
    </keep-alive>
  </div>
</template>

<script>
import services from "@/utils/services";
import { VanOffline, QrVanOffline } from "@/components";
import { mapGetters } from "vuex";

export default {
  name: "report",
  components: {
    VanOffline,
    QrVanOffline,
  },
  data: () => ({
    loading: false,
  }),
  mounted() {},
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
    ...mapGetters("vanOffline", ["vanOffline"]),
  },
  methods: {},
};
</script>

<style scoped>
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #a4a0a0 !important;
}
</style>
